<template>
  <header class="app_topbar">
    <div class="app_topbar__inner">
      <div class="app_topbar__left">
        <button
          v-if="showToggle"
          type="button"
          class="app_topbar__icon-btn"
          :aria-label="toggleAriaLabel"
          :title="toggleAriaLabel"
          @click="$emit('toggle-sidebar')"
        >
          <fuse-icon :name="toggleIconName" :size="iconLg" />
        </button>

        <button
          v-if="showLogo"
          type="button"
          class="app_topbar__logo-btn"
          aria-label="Ir a página principal"
          @click="$emit('go-home')"
        >
          <img
            v-if="companyLogoUrl"
            class="app_topbar__logo-img"
            :src="companyLogoUrl"
            alt="Logo"
          >
          <img
            v-else
            class="app_topbar__logo-img"
            src="../../assets/img/logo.png"
            alt="Logo"
          >
        </button>
      </div>

      <div class="app_topbar__user">
        <v-menu
          v-model="menuOpen"
          offset-y
          left
          :nudge-bottom="8"
          content-class="user_menu"
          transition="slide-y-transition"
          @input="onMenuInput"
        >
          <template v-slot:activator="{ on }">
            <button
              ref="userMenuActivator"
              type="button"
              class="app_topbar__profile"
              v-on="on"
              aria-label="Menú de usuario"
              aria-haspopup="true"
            >
              <span class="app_topbar__avatar" aria-hidden="true">{{ userInitials }}</span>
              <span class="app_topbar__meta">
                <span class="app_topbar__email">{{ userEmail }}</span>
                <span class="app_topbar__role">{{ userRole }}</span>
              </span>
              <fuse-icon name="chevron-down" :size="iconSm" class="app_topbar__meta-chevron" />
            </button>
          </template>
          <div class="user_menu__panel" :style="menuPanelStyle">
            <button
              type="button"
              class="user_menu__action"
              @click="$emit('logout')"
            >
              <fuse-icon name="log-out" :size="iconMd" class="user_menu__action-icon" />
              <span>Cerrar sesión</span>
            </button>
          </div>
        </v-menu>
      </div>
    </div>
  </header>
</template>

<script>
import FuseIcon from './FuseIcon.vue'
import { ICON_SIZE } from './iconMap'

export default {
  name: 'AppTopbar',
  components: { FuseIcon },
  props: {
    userEmail: {
      type: String,
      default: ''
    },
    userInitials: {
      type: String,
      default: '?'
    },
    userRole: {
      type: String,
      default: 'Administrador'
    },
    sidebarOpen: {
      type: Boolean,
      default: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    companyLogoUrl: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    menuOpen: false,
    menuWidth: 0,
    iconSm: ICON_SIZE.sm,
    iconMd: ICON_SIZE.md,
    iconLg: ICON_SIZE.lg
  }),
  computed: {
    menuPanelStyle() {
      if (!this.menuWidth) return {}
      return {
        width: this.menuWidth + 'px',
        minWidth: this.menuWidth + 'px',
        maxWidth: this.menuWidth + 'px',
        boxSizing: 'border-box'
      }
    },
    showToggle() {
      return this.isMobile || !this.collapsed
    },
    toggleIconName() {
      if (this.isMobile) {
        return this.sidebarOpen ? 'panel-left-close' : 'panel-left-open'
      }
      return this.collapsed ? 'panel-left-open' : 'panel-left-close'
    },
    toggleAriaLabel() {
      if (this.isMobile) {
        return this.sidebarOpen ? 'Cerrar menú' : 'Abrir menú'
      }
      return this.collapsed ? 'Expandir menú' : 'Contraer menú'
    }
  },
  methods: {
    onMenuInput(isOpen) {
      if (!isOpen) return
      this.$nextTick(() => {
        const activator = this.$refs.userMenuActivator
        if (!activator || !activator.offsetWidth) return
        this.menuWidth = activator.offsetWidth
        const menu = document.querySelector('.user_menu.v-menu__content')
        if (menu) {
          menu.style.width = activator.offsetWidth + 'px'
          menu.style.minWidth = activator.offsetWidth + 'px'
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/AppTopbar.vue